import { all } from 'redux-saga/effects';
import { telemetrySupraConnectionSaga } from '../../Supra/supraConnectionTelemetrySagas';

export const frontDeviceTelemetrySaga = () =>
	function* () {
		const telemetrySagas = [telemetrySupraConnectionSaga];
		const telemetrySagaIterators = telemetrySagas.map((saga) => {
			return saga();
		});
		yield all(telemetrySagaIterators);
	};
